import { createContext, useContext, type ReactNode } from 'react'

import { createPortal } from 'react-dom'

const FiltersSlotContext = createContext<HTMLElement | null>(null)

export const FiltersSlotProvider = FiltersSlotContext.Provider

/**
 * Renders its children into the page-chrome filters slot (next to the refresh
 * button) when a slot is provided by the surrounding page; otherwise renders
 * inline. Each tab wraps its existing filter UI in this component so the same
 * controls visually land in the topbar without lifting filter state out of
 * the tabs.
 */
export const FiltersPortal = ({ children }: { children: ReactNode }) => {
  const slot = useContext(FiltersSlotContext)
  if (slot) return createPortal(children, slot)
  return <>{children}</>
}
